import { ContratoAplicativoInicial } from "../models/contratoAplicativoModel"
import type { ContratoAplicativoModel } from "../models/contratoAplicativoModel"
import { ContratoAplicativoActionsTypes } from "./contratoAplicativoActions"
import type { ContratoAplicativoActionModel } from "./contratoAplicativoActions"

export function contratoAplicativoReducer(
    state: ContratoAplicativoModel,
    action: ContratoAplicativoActionModel
): ContratoAplicativoModel {
    switch (action.type) {
        case ContratoAplicativoActionsTypes.CARREGAR:
            return action.payload

        case ContratoAplicativoActionsTypes.ATUALIZAR_CAMPO:
            return {
                ...state,
                [action.payload.campo]: action.payload.valor,
            }

        case ContratoAplicativoActionsTypes.RESETAR:
            return ContratoAplicativoInicial

        default:
            return state
    }
}

export { ContratoAplicativoInicial }
